module.exports = __webpack_public_path__ + "static/media/UST.eec3a54e.svg";